/** @format */

const Text = ({ field, onChangeValue, teamForm }) => {
	return (
		<>
			{field?.foreigners !== undefined && field?.isForeigners ? (
				<>
					<label>{field.label}</label>
					<div className='input-group mb-3'>
						<input
							onChange={(e) =>
								onChangeValue(field.name, 'FGN-' + e.target.value, teamForm)
							}
							type='text'
							defaultValue={field?.value ?? ''}
							className='form-control f-13'
						/>
						<div className='input-group-append'>
							<span
								className='input-group-text text-dark f-12'
								id='basic-addon1'>
								FGN
							</span>
						</div>
					</div>
				</>
			) : (
				<div className='form-group d-flex flex-column'>
					<label>{field.label}</label>
					<input
						onChange={(e) =>
							onChangeValue(field.name, e.target.value, teamForm)
						}
						type='text'
						defaultValue={field?.value ?? ''}
						className='form-control f-13'
					/>
				</div>
			)}
		</>
	);
};

export default Text;
